import React, { useState, useEffect } from 'react';
import OppForm from './components/OppForm';
import './index.css';
import logger from './utils/logger'; // Import the logger

function App() {
  const [entityId, setEntityId] = useState(null);

  useEffect(() => {
    window.ZOHO.embeddedApp.on("PageLoad", function(data) {
      const recordId = data.EntityId[0]; // Extract the first value from the EntityId array
      setEntityId(recordId);
      logger.debug("EntityId captured on load:", recordId); // Use logger
    });

    window.ZOHO.embeddedApp.init();
  }, []);

  return (
    <div className="App">
      {entityId ? <OppForm EntityId={entityId} /> : <p>Loading...</p>}
    </div>
  );
}

export default App;